// Auto-generated stub — RE/Infra module removed for Process-only cleanup.
// Kept so legacy imports still resolve; renders a no-op placeholder.
import React from "react";
export default function InfraStagePanel() { return null; }
